import { Navigate, useRoutes } from "react-router-dom";
import GuestGuard from "auth/GuestGuard";
import CompactLayout from "layouts/compact";
import DashboardLayout from "layouts/dashboard";
import BlankLayout from "layouts/BlankLayout";
import {
  Banner,
  Batch,
  Stream,
  Board,
  ChangePassword,
  Chapter,
  City,
  Class,
  Content,
  Course,
  CreateBanner,
  CreateBatch,
  CreateStream,
  CreateBoard,
  CreateChapter,
  CreateClass,
  CreateContent,
  CreateCourse,
  CreateFeature,
  CreateGallery,
  CreateHowItHelps,
  CreateLiveClass,
  CreatePackage,
  CreatePakacgeSubscription,
  CreateShorts,
  CreateStaff,
  CreateSubject,
  CreateSubscriptionList,
  CreateTopic,
  CreateWantToBe,
  CreateWhyYouNeed,
  Dashboard,
  Doubts,
  DoubtsReply,
  Enquiry,
  Feature,
  Gallery,
  HowItHelps,
  Instructions,
  LiveClass,
  Login,
  NewPassword,
  Orders,
  Package,
  PackageSubscription,
  PackageSubscriptionList,
  Page404,
  PaymentSettings,
  Payments,
  Permission,
  ResetPassword,
  Schedule,
  CreateSchedule,
  ScholarshipApplication,
  Shorts,
  SiteSettings,
  State,
  Subject,
  Topic,
  VerifyCode,
  WantToBe,
  WhyYouNeed,
  ZoomMeeting,
  CreateFaq,
  Faq,
  CreateOnlyForYou,
  OnlyForYou,
  CreateStudent,
  StudentProfile,
  StudentAttendance,
  QuestionBulkUpload,
  Notice,
  CreateNotice,
  Revision,
  CreateRevision,
  UploadBulkRevision,
  TestReportList,
  TestReportId,
  TestQuestion,
  QuestionBank,
  CreateQuestionBank,
  TestQuestionView,
  Scholarship,
  CreateScholarship,
  ScholarshipClass,
  CreateScholarshipClass,
  HistoryLive,
  Assignment,
  CreateAssignment,
  AssignmentResult,
  DoubtDemoRequest,
  Activity,
  BulkUploadStudent,
  IndivisualSetting,
  Students,
  StudentRequest,
  Roles,
  Feedback,
  // CreateTest,
  Staff,
  BulkUploadStaff,
  QuizReportList,
  QuizReportId,
  TopHighlight,
  CreateHighlight,
  Offline,
  Online,
  BulkTopic,
  StaffAttendance,
  Questions,
  BulkVideo,
  StudentOwnTest,
  StudentOwnTestId,
  Ratings,
  LiveClassRatings,
  MentorshipPackage,
  ZoomSetting,
  FireBaseSetting,
  CreateZoomSetting,
  ScholarshipTest,
  CreateScholarshipTest,
  ImagesBookmark,
  ScholarshipTestReport,
  ProductPackage,
  CreateProductPackage,
  Category,
  SubCategory,
  GrievancesList,
  ChapterBulkUpload,
  YoutubeMeeting,
  YoutubeMeetingFree,
  Language,
  CreateLanguage,
  Voucher,
  CreateVoucher,
  OrderHistory,
  StudentProfileinPackage,
  StudentProfileinDashboard,
  PyqsList,
  CreatePyqs,
  ModalPaperList,
  CreateModalPaper,
  FreeLiveClass,
  CreateFreeLiveClass,
  QuestionOfTheDay,
  CreateQuestionOfTheDay,
  QuestionOfTheBulkUpload,
  WordOfTheDay,
  CreateWordOfTheDay,
  WordOfTheBulkUpload,
  VocabOfTheDay,
  CreateVocabOfTheDay,
  VocabOfTheBulkUpload,
  Grammar,
  CreateGrammar,
  Idioms,
  CreateIdioms,
  IdiomsBulkUpload,
  SyllabusMocktest,
  CreateSyllabusMocktest,
  AboutMocktest,
  CreateAboutMocktest,
  InstructionMocktest,
  CreateInstructionMocktest,
  AimtTest,
  AimcTestQuestionView,
  CreateAimtTest,
  DailyTest,
  CreateDailyTest,
  // DailyTestQuestions,
  DailyTestQuestionView,
  GoalMapping,
  CreateGoalMapping,
  MasterStudyMaterial,
  CreateMasterStudyMaterial,
  GoalStudyMaterialMapping,
  CreateGoalStudyMaterialMapping,
  ViewQuestion,
  UserReferAndEarn,
  CreateUserReferAndEarn,
  AgentReferAndEarn,
  CreateAgentReferAndEarn,
  PracticeTest,
  CreatePracticeTest,
  MasterTest,
  CreateMasterTest,
  AgentMasterVoucher,
  CreateAgentMasterVoucher,
  CreateGoalStudyMaterialBulkUpload,
  WallOfFame,
  CreateWallOfFame,
  BulkWallOfFrame,
  MasterCurriculum,
  CreateMasterCurriculum,
  CurriculumContent,
  CreateCurriculumContent,
  CurriculumContentBulkUpload,
  DailyUseSentences,
  CreateDailyUseSentences,
  BulkDailyUseSentences,
  MasterDailySentences,
  CreateMasterDailySentences,
  BulkMasterDailySentences,
  StreakBadges,
  CreateStreakBadges,
  GuessPaper,
  CreateGuessPaper,
  GuessPaperQuestionView,
  SpeedLearn,
  CreateSpeedLearn,
  SpeedLearnMap,
  CreateSpeedLearnMap,
  LiveClassTest,
  CreateLiveClassTest,
  LiveClassQuestionView,
  StoreProduct,
  CreateStoreProduct,
  StoreOrders,
  VideoCard,
  CreateVideoCard,
  EducatorVoucher,
  CreateEducatorVoucher,
} from "./elements";
import AuthMiddleware from "layouts/Middleware/AuthMiddleware";
import NavigateMiddleware from "layouts/Middleware/NavigateMiddleware";
import RoutePermissionMiddleware from "layouts/Middleware/RoutePermissionMiddleware";

export default function Router() {
  return useRoutes([
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: "reset-password", element: <ResetPassword /> },
            { path: "new-password", element: <NewPassword /> },
            { path: "verify", element: <VerifyCode /> },
          ],
        },
      ],
    },
    {
      path: "app",
      element: (
        <AuthMiddleware>
          <NavigateMiddleware>
            <RoutePermissionMiddleware>
              <DashboardLayout />
            </RoutePermissionMiddleware>
          </NavigateMiddleware>
        </AuthMiddleware>
      ),
      children: [
        { path: "dashboard", element: <Dashboard /> },

        // COURSE
        { path: "master/course", element: <Course /> },
        { path: "master/course/create", element: <CreateCourse /> },
        { path: "master/course/edit/:id", element: <CreateCourse /> },
        // BOARD
        { path: "master/board", element: <Board /> },
        { path: "master/board/create", element: <CreateBoard /> },
        { path: "master/board/edit/:id", element: <CreateBoard /> },
        // CLASS
        { path: "master/class", element: <Class /> },
        { path: "master/class/create", element: <CreateClass /> },
        { path: "master/class/edit/:id", element: <CreateClass /> },
        // BATCH TYPE
        { path: "master/batch-type", element: <Batch /> },
        { path: "master/batch-type/create", element: <CreateBatch /> },
        { path: "master/batch-type/edit/:id", element: <CreateBatch /> },

        // Stream
        { path: "master/stream", element: <Stream /> },
        { path: "master/stream/create", element: <CreateStream /> },
        { path: "master/stream/edit/:id", element: <CreateStream /> },

        // Goal Mapping
        { path: "master/goalmapping", element: <GoalMapping /> },
        { path: "master/goalmapping/create", element: <CreateGoalMapping /> },
        { path: "master/goalmapping/edit/:id", element: <CreateGoalMapping /> },

        // SUBJECT
        { path: "master/subject", element: <Subject /> },
        { path: "master/subject/create", element: <CreateSubject /> },
        { path: "master/subject/edit/:id", element: <CreateSubject /> },
        // CHAPTER
        { path: "master/chapter", element: <Chapter /> },
        { path: "master/chapter/create", element: <CreateChapter /> },
        { path: "master/chapter/edit/:id", element: <CreateChapter /> },
        // STATES
        { path: "master/state", element: <State /> },
        // CITY
        { path: "master/city", element: <City /> },

        //Product
        { path: "master/package", element: <ProductPackage /> },
        { path: "master/package/create", element: <CreateProductPackage /> },
        {
          path: "master/package/edit/:id",
          element: <CreateProductPackage />,
        },
        {
          path: "master/package/student/profile/:id",
          element: <StudentProfileinPackage />,
        },
        {
          path: "dashboard/profile/:id",
          element: <StudentProfileinDashboard />,
        },

        //Store
        { path: "store/store-product", element: <StoreProduct /> },
        { path: "store/store-product/create", element: <CreateStoreProduct /> },
        {
          path: "store/store-product/edit/:id",
          element: <CreateStoreProduct />,
        },
        {
          path: "store/store-order",
          element: <StoreOrders />,
        },

        //Video Card
        { path: "videocard", element: <VideoCard /> },
        { path: "videocard/create", element: <CreateVideoCard /> },
        {
          path: "videocard/edit/:id",
          element: <CreateVideoCard />,
        },

        //Language
        { path: "master/language", element: <Language /> },
        { path: "master/language/create", element: <CreateLanguage /> },
        { path: "master/language/edit/:id", element: <CreateLanguage /> },

        //Voucher
        { path: "mastervoucher/voucher", element: <Voucher /> },
        { path: "mastervoucher/voucher/create", element: <CreateVoucher /> },
        { path: "mastervoucher/voucher/edit/:id", element: <CreateVoucher /> },

        //Educator Voucher
        { path: "mastervoucher/educatorvoucher", element: <EducatorVoucher /> },
        {
          path: "mastervoucher/educatorvoucher/create",
          element: <CreateEducatorVoucher />,
        },
        {
          path: "mastervoucher/educatorvoucher/edit/:id",
          element: <CreateEducatorVoucher />,
        },

        // Category
        { path: "master/category", element: <Category /> },
        // SubCategory
        { path: "master/subcategory", element: <SubCategory /> },
        // Images Bookmark
        { path: "master/images-bookmark", element: <ImagesBookmark /> },
        // WANT TO BE
        { path: "master/want-to-be", element: <WantToBe /> },
        { path: "master/want-to-be/create", element: <CreateWantToBe /> },
        { path: "master/want-to-be/edit/:id", element: <CreateWantToBe /> },
        // STAFF
        { path: "staff-manager/staff-list", element: <Staff /> },
        { path: "staff-manager/staff/create", element: <CreateStaff /> },
        { path: "staff-manager/staff/edit/:id", element: <CreateStaff /> },
        {
          path: "staff-manager/staff-attendance/:id",
          element: <StaffAttendance />,
        },
        {
          path: "staff-manager/bulk-upload-staff",
          element: <BulkUploadStaff />,
        },

        // Wall of Fame
        {
          path: "walloffame",
          element: <WallOfFame />,
        },
        {
          path: "walloffame/create",
          element: <CreateWallOfFame />,
        },
        {
          path: "walloffame/edit/:id",
          element: <CreateWallOfFame />,
        },
        {
          path: "walloffame/bulk-upload-walloffame",
          element: <BulkWallOfFrame />,
        },

        //Speed Learn
        {
          path: "speedlearn/speedlearnmaster",
          element: <SpeedLearn />,
        },
        {
          path: "speedlearn/speedlearnmaster/create",
          element: <CreateSpeedLearn />,
        },
        {
          path: "speedlearn/speedlearnmaster/edit/:id",
          element: <CreateSpeedLearn />,
        },
        {
          path: "speedlearn/speedlearnmap",
          element: <SpeedLearnMap />,
        },
        {
          path: "speedlearn/speedlearnmap/create",
          element: <CreateSpeedLearnMap />,
        },
        {
          path: "speedlearn/speedlearnmap/edit/:id",
          element: <CreateSpeedLearnMap />,
        },

        // Study Material
        {
          path: "studymaterial/masterstudymaterial",
          element: <MasterStudyMaterial />,
        },
        {
          path: "studymaterial/masterstudymaterial/create",
          element: <CreateMasterStudyMaterial />,
        },
        {
          path: "studymaterial/masterstudymaterial/edit/:id",
          element: <CreateMasterStudyMaterial />,
        },
        {
          path: "studymaterial/goalstudymaterialmapping",
          element: <GoalStudyMaterialMapping />,
        },
        {
          path: "studymaterial/goalstudymaterialmapping/create",
          element: <CreateGoalStudyMaterialMapping />,
        },
        {
          path: "studymaterial/goalstudymaterialmapping/edit/:id",
          element: <CreateGoalStudyMaterialMapping />,
        },

        {
          path: "studymaterial/goalstudymaterialmapping/upload",
          element: <CreateGoalStudyMaterialBulkUpload />,
        },

        //Free Resource
        { path: "freeresource/pyqs", element: <PyqsList /> },
        { path: "freeresource/pyqs/create", element: <CreatePyqs /> },
        { path: "freeresource/pyqs/edit/:id", element: <CreatePyqs /> },

        //Modal Paper
        { path: "freeresource/model-paper", element: <ModalPaperList /> },
        {
          path: "freeresource/model-paper/create",
          element: <CreateModalPaper />,
        },
        {
          path: "freeresource/model-paper/edit/:id",
          element: <CreateModalPaper />,
        },

        //Spoken English -- Ques of the day
        {
          path: "spokenenglish/questionoftheday",
          element: <QuestionOfTheDay />,
        },
        {
          path: "spokenenglish/questionoftheday/create",
          element: <CreateQuestionOfTheDay />,
        },
        {
          path: "spokenenglish/questionoftheday/:id",
          element: <CreateQuestionOfTheDay />,
        },
        {
          path: "spokenenglish/questionoftheday/edit/:id",
          element: <CreateQuestionOfTheDay />,
        },

        {
          path: "spokenenglish/questionoftheday/questionbank-bulkupload",
          element: <QuestionOfTheBulkUpload />,
        },

        //Spoken English -- Word of the day
        {
          path: "spokenenglish/wordoftheday",
          element: <WordOfTheDay />,
        },
        {
          path: "spokenenglish/wordoftheday/create",
          element: <CreateWordOfTheDay />,
        },
        {
          path: "spokenenglish/wordoftheday/:id",
          element: <CreateWordOfTheDay />,
        },
        {
          path: "spokenenglish/wordoftheday/edit/:id",
          element: <CreateWordOfTheDay />,
        },
        {
          path: "spokenenglish/wordoftheday/wordbank-bulkupload",
          element: <WordOfTheBulkUpload />,
        },

        //Grammar

        //Spoken English -- Word of the day
        {
          path: "spokenenglish/grammar",
          element: <Grammar />,
        },
        {
          path: "spokenenglish/grammar/create",
          element: <CreateGrammar />,
        },
        {
          path: "spokenenglish/grammar/edit/:id",
          element: <CreateGrammar />,
        },

        //Spoken English -- Vocab of the day
        {
          path: "spokenenglish/vocabulary",
          element: <VocabOfTheDay />,
        },
        {
          path: "spokenenglish/vocabulary/create",
          element: <CreateVocabOfTheDay />,
        },
        {
          path: "spokenenglish/vocabulary/:id",
          element: <CreateVocabOfTheDay />,
        },
        {
          path: "spokenenglish/vocabulary/edit/:id",
          element: <CreateVocabOfTheDay />,
        },
        {
          path: "spokenenglish/vocabulary/vocabulary-bulkupload",
          element: <VocabOfTheBulkUpload />,
        },

        //Spoken English -- Idioms
        {
          path: "spokenenglish/idioms",
          element: <Idioms />,
        },
        {
          path: "spokenenglish/idioms/create",
          element: <CreateIdioms />,
        },
        {
          path: "spokenenglish/idioms/:id",
          element: <CreateIdioms />,
        },
        {
          path: "spokenenglish/idioms/edit/:id",
          element: <CreateIdioms />,
        },
        {
          path: "spokenenglish/idioms/idioms-bulkupload",
          element: <IdiomsBulkUpload />,
        },

        // Curriculum
        {
          path: "spokenenglish/mastercurriculum",
          element: <MasterCurriculum />,
        },
        {
          path: "spokenenglish/mastercurriculum/create",
          element: <CreateMasterCurriculum />,
        },
        {
          path: "spokenenglish/mastercurriculum/:id",
          element: <CreateMasterCurriculum />,
        },
        {
          path: "spokenenglish/mastercurriculum/edit/:id",
          element: <CreateMasterCurriculum />,
        },
        {
          path: "spokenenglish/curriculumcontent",
          element: <CurriculumContent />,
        },
        {
          path: "spokenenglish/curriculumcontent/create",
          element: <CreateCurriculumContent />,
        },
        {
          path: "spokenenglish/curriculumcontent/:id",
          element: <CreateCurriculumContent />,
        },
        {
          path: "spokenenglish/curriculumcontent/edit/:id",
          element: <CreateCurriculumContent />,
        },
        {
          path: "spokenenglish/curriculumcontent/bulk-upload-content",
          element: <CurriculumContentBulkUpload />,
        },
        {
          path: "spokenenglish/dailyusesentences",
          element: <DailyUseSentences />,
        },
        {
          path: "spokenenglish/dailyusesentences/create",
          element: <CreateDailyUseSentences />,
        },
        {
          path: "spokenenglish/dailyusesentences/:id",
          element: <CreateDailyUseSentences />,
        },
        {
          path: "spokenenglish/dailyusesentences/edit/:id",
          element: <CreateDailyUseSentences />,
        },
        {
          path: "spokenenglish/dailyusesentences/bulk-upload-sentences",
          element: <BulkDailyUseSentences />,
        },

        //Master Daily use Sentences
        {
          path: "spokenenglish/masterdailysentences",
          element: <MasterDailySentences />,
        },
        {
          path: "spokenenglish/masterdailysentences/create",
          element: <CreateMasterDailySentences />,
        },
        {
          path: "spokenenglish/masterdailysentences/:id",
          element: <CreateMasterDailySentences />,
        },
        {
          path: "spokenenglish/masterdailysentences/edit/:id",
          element: <CreateMasterDailySentences />,
        },
        {
          path: "spokenenglish/masterdailysentences/bulk-upload-master-sentences",
          element: <BulkMasterDailySentences />,
        },

        //Bulk Upload chapter
        {
          path: "master/chapter/bulk-upload-Chapter",
          element: <ChapterBulkUpload />,
        },

        // BANNER
        { path: "master/banner", element: <Banner /> },
        { path: "master/banner/create", element: <CreateBanner /> },
        { path: "master/banner/edit/:id", element: <CreateBanner /> },
        // SYLLABUS TOPIC
        { path: "syllabus/topic", element: <Topic /> },
        { path: "syllabus/topic/create", element: <CreateTopic /> },
        { path: "syllabus/topic/edit/:id", element: <CreateTopic /> },
        { path: "syllabus/bulk-upload-topic", element: <BulkTopic /> },
        { path: "syllabus/bulk-upload-video", element: <BulkVideo /> },
        // SYLLABUS CONTENT
        { path: "syllabus/content", element: <Content /> },
        { path: "syllabus/content/create", element: <CreateContent /> },
        { path: "syllabus/content/edit/:id", element: <CreateContent /> },
        // SYLLABUS CONTENT BULK Hide For Now
        // { path: "syllabus/Createvideomanagerbulk/create", element: <CreateVideoManagerBulk /> },
        // SCHEDULE
        { path: "schedule", element: <Schedule /> },
        { path: "schedule/create", element: <CreateSchedule /> },

        // Streak Badges
        {
          path: "streak/badges",
          element: <StreakBadges />,
        },
        {
          path: "streak/badges/create",
          element: <CreateStreakBadges />,
        },
        { path: "streak/badges/edit/:id", element: <CreateStreakBadges /> },

        //AI Mock Test
        {
          path: "allindiamocktest/aimtsyllabus",
          element: <SyllabusMocktest />,
        },
        {
          path: "allindiamocktest/aimtsyllabus/create",
          element: <CreateSyllabusMocktest />,
        },
        {
          path: "allindiamocktest/aimtsyllabus/edit/:id",
          element: <CreateSyllabusMocktest />,
        },
        {
          path: "allindiamocktest/aimtabout",
          element: <AboutMocktest />,
        },
        {
          path: "allindiamocktest/aimtabout/create",
          element: <CreateAboutMocktest />,
        },
        {
          path: "allindiamocktest/aimtabout/edit/:id",
          element: <CreateAboutMocktest />,
        },
        {
          path: "allindiamocktest/instruction",
          element: <InstructionMocktest />,
        },
        {
          path: "allindiamocktest/instruction/create",
          element: <CreateInstructionMocktest />,
        },
        {
          path: "allindiamocktest/instruction/edit/:id",
          element: <CreateInstructionMocktest />,
        },

        {
          path: "allindiamocktest/aimttest",
          element: <AimtTest />,
        },
        {
          path: "allindiamocktest/aimttest/create",
          element: <CreateAimtTest />,
        },
        {
          path: "allindiamocktest/aimttest/edit/:id",
          element: <CreateAimtTest />,
        },

        {
          path: "allindiamocktest/aimttest/questions/:id",
          element: <AimcTestQuestionView />,
        },

        //Daily Test
        {
          path: "allindiamocktest/dailytest",
          element: <DailyTest />,
        },
        {
          path: "allindiamocktest/dailytest/create",
          element: <CreateDailyTest />,
        },
        {
          path: "allindiamocktest/dailytest/edit/:id",
          element: <CreateDailyTest />,
        },
        // {
        //   path: "allindiamocktest/dailytest/questions",
        //   element: <DailyTestQuestions />,
        // },
        {
          path: "allindiamocktest/dailytest/questions/:id",
          element: <DailyTestQuestionView />,
        },

        //Guess Paper
        {
          path: "allindiamocktest/guesspaper",
          element: <GuessPaper />,
        },
        {
          path: "allindiamocktest/guesspaper/create",
          element: <CreateGuessPaper />,
        },
        {
          path: "allindiamocktest/guesspaper/edit/:id",
          element: <CreateGuessPaper />,
        },
        {
          path: "allindiamocktest/guesspaper/questions/:id",
          element: <GuessPaperQuestionView />,
        },

        //Refer and Earn (User & Agent)
        {
          path: "referandearn/user",
          element: <UserReferAndEarn />,
        },
        {
          path: "referandearn/user/create",
          element: <CreateUserReferAndEarn />,
        },
        {
          path: "referandearn/user/edit/:id",
          element: <CreateUserReferAndEarn />,
        },
        {
          path: "referandearn/agent",
          element: <AgentReferAndEarn />,
        },
        {
          path: "referandearn/agent/create",
          element: <CreateAgentReferAndEarn />,
        },
        {
          path: "referandearn/agent/edit/:id",
          element: <CreateAgentReferAndEarn />,
        },

        //Master Voucher
        {
          path: "mastervoucher/agent",
          element: <AgentMasterVoucher />,
        },
        {
          path: "mastervoucher/agent/create",
          element: <CreateAgentMasterVoucher />,
        },
        {
          path: "mastervoucher/agent/edit/:id",
          element: <CreateAgentMasterVoucher />,
        },

        // NOTICE
        { path: "notice", element: <Notice /> },
        { path: "notice/create", element: <CreateNotice /> },
        { path: "notice/edit/:id", element: <CreateNotice /> },
        // REVISION
        { path: "revision", element: <Revision /> },
        { path: "revision/create", element: <CreateRevision /> },
        { path: "revision/edit/:id", element: <CreateRevision /> },
        {
          path: "revision/revision-bulkupload",
          element: <UploadBulkRevision />,
        },
        // QUESTION BANK
        {
          path: "questionbank/questionbank-singleupload",
          element: <QuestionBank />,
        },
        { path: "questionbank/:id", element: <CreateQuestionBank /> },
        { path: "questionbank/create", element: <CreateQuestionBank /> },
        { path: "questionbank/edit/:id", element: <CreateQuestionBank /> },
        { path: "questionbank/view/:id", element: <ViewQuestion /> },
        {
          path: "questionbank/questionbank-bulkupload",
          element: <QuestionBulkUpload />,
        },
        // STUDENT
        { path: "student-manager/student-list", element: <Students /> },
        {
          path: "student-manager/student/profile/:id",
          element: <StudentProfile />,
        },
        { path: "student-manager/student/create", element: <CreateStudent /> },
        {
          path: "student-manager/student/edit/:id",
          element: <CreateStudent />,
        },
        {
          path: "ratings/app-ratings",
          element: <Ratings />,
        },
        {
          path: "educator-ratings/liveclass-ratings",
          element: <LiveClassRatings />,
        },
        // STUDENT ATTENDENCE
        {
          path: "student-manager/student-attendance/:id",
          element: <StudentAttendance />,
        },
        //BULK UPLOAD
        {
          path: "student-manager/student/bulk-upload",
          element: <BulkUploadStudent />,
        },
        // STUDENT REQUEST
        {
          path: "student-manager/student-request",
          element: <StudentRequest />,
        },
        {
          path: "educator-ratings/feedback",
          element: <Feedback />,
        },
        { path: "student-manager/order", element: <Orders /> },
        { path: "student-manager/payment", element: <Payments /> },
        // DOUBTS
        { path: "doubts", element: <Doubts /> },
        { path: "doubts/:id", element: <DoubtsReply /> },
        // SHORTS
        { path: "short", element: <Shorts /> },
        { path: "short/create", element: <CreateShorts /> },
        { path: "short/edit/:id", element: <CreateShorts /> },
        // FAQ
        { path: "faq", element: <Faq /> },
        { path: "faq/create", element: <CreateFaq /> },
        { path: "faq/edit/:id", element: <CreateFaq /> },
        // ACTIVITY
        { path: "activity", element: <Activity /> },
        // SCHOLORSHIP
        { path: "scholarship/scholarship-create", element: <Scholarship /> },
        { path: "scholarship/create", element: <CreateScholarship /> },
        { path: "scholarship/edit/:id", element: <CreateScholarship /> },
        {
          path: "scholarship/scholarship-class",
          element: <ScholarshipClass />,
        },
        {
          path: "scholarship/scholarship-class/create",
          element: <CreateScholarshipClass />,
        },
        {
          path: "scholarship/scholarship-class/edit/:id",
          element: <CreateScholarshipClass />,
        },
        { path: "scholarship/top-highlight", element: <TopHighlight /> },

        {
          path: "scholarship/top-highlight/create",
          element: <CreateHighlight />,
        },
        {
          path: "scholarship/top-highlight/edit/:id",
          element: <CreateHighlight />,
        },
        //Create Scholarship Test
        {
          path: "scholarshiptest/scholarship-test",
          element: <ScholarshipTest />,
        },
        { path: "scholarshiptest/create", element: <CreateScholarshipTest /> },
        {
          path: "scholarshiptest/edit/:id",
          element: <CreateScholarshipTest />,
        },

        // ASSIGNMENT
        { path: "assignment/assignment-create", element: <Assignment /> },
        { path: "assignment/create", element: <CreateAssignment /> },
        { path: "assignment/edit/:id", element: <CreateAssignment /> },
        { path: "assignment/assignment-result", element: <AssignmentResult /> },
        {
          path: "assignment/assignment-offline-mode/:id",
          element: <Offline />,
        },
        { path: "assignment/assignment-online-mode/:id", element: <Online /> },
        // PACKAGE
        { path: "subscription/package-master", element: <Package /> },
        {
          path: "subscription/package-master/create",
          element: <CreatePackage />,
        },
        {
          path: "subscription/package-master/edit/:id",
          element: <CreatePackage />,
        },
        {
          path: "subscription/package-details",
          element: <PackageSubscription />,
        },
        {
          path: "subscription/package-details/create",
          element: <CreatePakacgeSubscription />,
        },
        {
          path: "subscription/package-details/edit/:id",
          element: <CreatePakacgeSubscription />,
        },
        {
          path: "subscription/Subscription-plan",
          element: <PackageSubscriptionList />,
        },
        {
          path: "subscription/Subscription-plan/create",
          element: <CreateSubscriptionList />,
        },
        {
          path: "subscription/Subscription-plan/edit/:id",
          element: <CreateSubscriptionList />,
        },
        // ONLY FOR YOU
        { path: "only-for-you", element: <OnlyForYou /> },
        { path: "only-for-you/create", element: <CreateOnlyForYou /> },
        { path: "only-for-you/edit/:id", element: <CreateOnlyForYou /> },
        // TEST
        { path: "test/test-report", element: <TestReportList /> },
        { path: "test/test-report/:id", element: <TestReportId /> },
        { path: "test/test-questions", element: <TestQuestion /> },
        { path: "test/test-questions/questions", element: <Questions /> },
        { path: "test/test-questions/:id", element: <TestQuestionView /> },
        { path: "test/student-own-test", element: <StudentOwnTest /> },
        { path: "test/student-own-test/:id", element: <StudentOwnTestId /> },

        //Practice Test
        { path: "test/test-master", element: <MasterTest /> },
        { path: "test/test-master/create", element: <CreateMasterTest /> },
        {
          path: "test/test-master/edit/:id",
          element: <CreateMasterTest />,
        },

        //Practice Test
        { path: "test/test-practice", element: <PracticeTest /> },
        { path: "test/test-practice/create", element: <CreatePracticeTest /> },
        {
          path: "test/test-practice/edit/:id",
          element: <CreatePracticeTest />,
        },

        // MENTORSHIP
        { path: "mentorship/feature", element: <Feature /> },
        { path: "mentorship/feature/create", element: <CreateFeature /> },
        { path: "mentorship/feature/edit/:id", element: <CreateFeature /> },

        { path: "mentorship/why-you-need", element: <WhyYouNeed /> },
        {
          path: "mentorship/why-you-need/create",
          element: <CreateWhyYouNeed />,
        },
        {
          path: "mentorship/why-you-need/edit/:id",
          element: <CreateWhyYouNeed />,
        },
        { path: "mentorship/how-it-help", element: <HowItHelps /> },
        {
          path: "mentorship/how-it-help/create",
          element: <CreateHowItHelps />,
        },
        {
          path: "mentorship/how-it-help/edit/:id",
          element: <CreateHowItHelps />,
        },
        {
          path: "mentorship/mentorship-package",
          element: <MentorshipPackage />,
        },
        // CHANGE PASSWORD
        { path: "change-password", element: <ChangePassword /> },
        // GENERAL SETTINGS
        {
          path: "general-setting/instruction-setting",
          element: <Instructions />,
        },
        {
          path: "general-setting/payment-setting",
          element: <PaymentSettings />,
        },
        { path: "general-setting/site-setting", element: <SiteSettings /> },
        {
          path: "general-setting/indivisual-setting",
          element: <IndivisualSetting />,
        },

        {
          path: "general-setting/zoom-setting",
          element: <ZoomSetting />,
        },
        {
          path: "general-setting/zoom-setting/create",
          element: <CreateZoomSetting />,
        },

        {
          path: "general-setting/zoom-setting/edit/:id",
          element: <CreateZoomSetting />,
        },

        {
          path: "general-setting/fire-base-setting",
          element: <FireBaseSetting />,
        },
        // GALLARY MANAGER
        { path: "gallery", element: <Gallery /> },
        { path: "gallery/create", element: <CreateGallery /> },
        { path: "gallery/edit/:id", element: <CreateGallery /> },
        // ACEDEMICS LIVE
        { path: "academics/live-class", element: <LiveClass /> },
        { path: "academics/live-class/:id", element: <YoutubeMeeting /> },
        { path: "academics/live-class/create", element: <CreateLiveClass /> },
        { path: "academics/live-class/edit/:id", element: <CreateLiveClass /> },
        { path: "academics/freelive-class", element: <FreeLiveClass /> },
        {
          path: "academics/freelive-class/create",
          element: <CreateFreeLiveClass />,
        },
        {
          path: "academics/freelive-class/:id",
          element: <YoutubeMeetingFree />,
        },
        {
          path: "academics/freelive-class/edit/:id",
          element: <CreateFreeLiveClass />,
        },
        { path: "academics/history", element: <HistoryLive /> },
        { path: "academics/doubt-demo-request", element: <DoubtDemoRequest /> },

        //Live Class Test
        { path: "academics/live-class-test", element: <LiveClassTest /> },
        {
          path: "academics/live-class-test/create",
          element: <CreateLiveClassTest />,
        },
        {
          path: "academics/live-class-test/edit/:id",
          element: <CreateLiveClassTest />,
        },
        {
          path: "academics/live-class-test/questions/:id",
          element: <LiveClassQuestionView />,
        },

        // SCHOLARSHIP APPLICATION
        {
          path: "scholorship-application",
          element: <ScholarshipApplication />,
        },
        {
          path: "scholorship-application/scholarship-testReport/:id",

          element: <ScholarshipTestReport />,
        },

        // ENQUIRY
        { path: "enquiry", element: <Enquiry /> },
        // ROLES
        { path: "master/roles", element: <Roles /> },
        // Quiz
        { path: "quiz/quiz-report", element: <QuizReportList /> },
        { path: "quiz/quiz-report/view/:id", element: <QuizReportId /> },
        { path: "master/roles/permission/:id", element: <Permission /> },

        // Grievances
        { path: "grievances", element: <GrievancesList /> },

        //order History
        { path: "orders", element: <OrderHistory /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },
    {
      element: <BlankLayout />,
      children: [{ path: "app/meeting/:id", element: <ZoomMeeting /> }],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
